import { render, staticRenderFns } from "./BaseGarantizados.vue?vue&type=template&id=50b8e852&"
import script from "./BaseGarantizados.vue?vue&type=script&lang=js&"
export * from "./BaseGarantizados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports